import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { PaginatorModule } from 'primeng/paginator';
import { FormsModule } from "@angular/forms";
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-test-primeng',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, PaginatorModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './client-associatelist.component.html',
  styleUrl: './client-associatelist.component.scss'
})

export class ClientAssociatelistComponent {
  @ViewChild('dt2') dt2: any;
  userName: any;
  companyName: any;
  lang: any;
  associatesList: any[] = [];
  monthDropdown: any;
  userCode: any;
  userRole: any;
  userConsent: string = 'yes';
  noticeHeading: string = '';
  noticeContent: string = '';
  // These hold filtered data
  visibleData: any[] = [];
  filteredData: any[] = [];
  totalCount: number = 0;
  dropDowndate: any;
  sectionId: any = '-1';
  emailToken: any;
  emailSuccess: boolean = false;
  timeSheetDate: string = '';
  
  // Manual pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 20;
  searchText: string = '';
  expandedRows: { [key: string]: boolean } = {};
  isLoading: boolean = true;
  adminLevel: number = 0;
  userEmail2: string = '';
  passwordExpiryDate: string = '';
  isMobileView: boolean = typeof window !== 'undefined' && window.innerWidth <= 1080 && window.matchMedia('(pointer: coarse)').matches;

  // 暗号化キャッシュ（パフォーマンス最適化）
  private encryptionCache = new Map<string, string>();

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private en: EncryptionService, private user: UserService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'jp');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  

  ngOnInit() {
    console.log('🚀 client-associatelist component initialized');
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.userRole = this.auth.getRole();
    this.companyName = this.auth.getCompanyName();
    this.adminLevel = this.auth.getAdminLevel() || 0;
    this.pageTitle.setTitle('menu.approvesingle');
    this.emailToken = null;

    this.loadUserEmail2();
    this.passwordExpiryDate = this.auth.getPasswordExpiryDate() || '';
    this.pageTitle.setTitle('menu.approvesingle');

    if (localStorage.getItem('emailtoken')) {
      this.emailToken = localStorage.getItem('emailtoken');    
    }

    if (isPlatformBrowser(this.platformId)) {
      // UserRoleがClientの場合のみ通知状態を確認
      if (this.userRole === 'Client') {
        this.userConsent = this.auth.getNotice() ?? 'no';
        this.getNotification();
      }
      
      console.time('⏱️ Total component load');
      this.getAssociates();
    }
  }

  loadUserEmail2() {
    this.userEmail2 = this.auth.getEmail() || '';
  }

  getNotification() {
    this.auth.getEmailContent() 
      .subscribe({
        next: (res: any) => {
          this.noticeContent = res.data.content;
          this.noticeHeading = res.data.title;
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
            return	
          }
        }
    })
  }

  giveConsent(isChecked: boolean) {
    if (isChecked) {
      let consentObj = {
        "termId": 2,
        "termValue": true
      }
      this.user.giveConsent(consentObj)
        .subscribe({
            next: (res: any) => {
            if (res.status) {
                this.auth.storeNotice('yes');
                this.userConsent = 'yes';

              } else {
                alert(res.message);
              }
          },
          error: (err: any) => {
            if(err.status === 401) {
              this.auth.logout();
              return;	
            }
          }
      })
    } else {
      this.userConsent = 'yes';
    }
  }

  acceptEmailChange() {
    const payLoad = {
      "token": this.emailToken,
      "confirm": true
    }

    this.user.acceptChangeEmail(payLoad)
      .subscribe({
        next: (res: any) => {
          // this.emailToken = null;
          if (res.status) {
            localStorage.removeItem('emailtoken');
            this.emailSuccess = true;
            this.user.clearUserProfileCache();
            this.user.getUserProfile().subscribe({
              next: (profileRes: any) => {
                if (profileRes.status) {
                  this.auth.storeEmail(profileRes.data.email2);
                  this.userEmail2 = profileRes.data.email2;
                }
              }
            });
          } else {
            localStorage.removeItem('emailtoken');            
            alert(res.message);
          }
        },
        error: (err: any) => {
          console.log(err);
		  if (err.status == 401) {
			  this.auth.logout();
			  return
			}
        }
    })
  }

  close() {
    this.emailSuccess = false;
  }

  // 暗号化キャッシュを使用して暗号化（パフォーマンス最適化）
  private encryptWithCache(value: string): string {
    if (this.encryptionCache.has(value)) {
      return this.encryptionCache.get(value)!;
    }
    
    const encrypted = Base64UrlService.encode(
      this.en.encryptionAES(value)
    );
    this.encryptionCache.set(value, encrypted);
    return encrypted;
  }

  getAssociates() {
    this.isLoading = true;
    console.time('⏱️ Parallel API Calls (getMonthListV2 + getAssociatesNew)');
    
    // 当月の最初の日付を計算（デフォルト値として使用）
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const defaultFormat = `${firstDayOfMonth.getFullYear()}-${String(firstDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(firstDayOfMonth.getDate()).padStart(2, '0')}`;
    
    // 真の並列実行: 2つのAPIを同時に呼び出す
    forkJoin({
      monthList: this.ts.getMonthListV2(),
      associates: this.ts.getAssociatesNew(defaultFormat, this.sectionId)
    }).subscribe({
      next: (results: any) => {
        console.timeEnd('⏱️ Parallel API Calls (getMonthListV2 + getAssociatesNew)');
        
        // 月リストの処理（空エントリを除外）
        this.monthDropdown = results.monthList.data.filter((d: any) => d.dayDate);
        
        // 空白行がある場合（当月のデータがない場合）、またはデータが空の場合
        if (!this.monthDropdown?.length) {
          this.dropDowndate = '';
          this.associatesList = [];
          this.isLoading = false;
          console.log('⚠️ No data available for current month');
          console.timeEnd('⏱️ Total component load');
          return;
        }
        
        const defaultEntry = this.monthDropdown.find((d: any) => d.isDefault) ?? this.monthDropdown[0];
        const [day, month, year] = defaultEntry.dayDate.split('-');
        const actualFormat = `${year}-${month}-${day}`;
        this.dropDowndate = `${day}-${month}-${year}`;
        this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(actualFormat));
        
        // アソシエイトリストの処理
        console.log('📊 Raw associates data count:', results.associates.data?.length);
        console.time('⏱️ Data Processing');
        
        // 最適化: 1回のループで全処理を実施 + 暗号化キャッシング（第1ソート: customerOfficeCode, 第2ソート: userCode）
        this.associatesList = [...(results.associates.data ?? [])].sort((a: any, b: any) =>
          (a.customerOfficeCode ?? '').localeCompare(b.customerOfficeCode ?? '', 'en', { sensitivity: 'variant' })
        ).map((section: any) => {
          const searchTexts = [section.customerOfficeName];
          
          const encryptedSummaries = [...(section.summaries ?? [])].sort((a: any, b: any) =>
            (a.userCode ?? '').localeCompare(b.userCode ?? '', 'en', { sensitivity: 'variant' })
          ).map((associates: any) => {
            searchTexts.push(associates.userName);
            
            return {
              ...associates,
              timesheetID: this.encryptWithCache(associates.timesheetID.toString()),
              userId: this.encryptWithCache(associates.userId.toString()),
              userIdOrg: associates.userId,
              timesheetIDOrg: associates.timesheetID
            };
          });
          
          const officeName = (section.customerOfficeName ?? '').slice(4);
          const officeCode = section.customerOfficeCode ?? '';
          const companyNamePart = (section.customerName ?? '').slice(9);

          console.log('🔍 section fields:', {
            customerOfficeCode: section.customerOfficeCode,
            customerName: section.customerName,
            customerOfficeName: section.customerOfficeName,
            officeName, officeCode, companyNamePart,
            adminLevel: this.adminLevel
          });

          const displaySection = officeName || (section.customerOfficeName ?? '');
          
          return {
            comSearchText: searchTexts.join(' ').toLowerCase(),
            ...section,
            displaySection,
            summaries: encryptedSummaries
          };
        });
        
        console.timeEnd('⏱️ Data Processing');
        
        this.totalCount = this.associatesList?.length;
        console.log('📊 Processed associates count:', this.associatesList?.length);
        this.applyFilters(); // Initialize filters and pagination
        this.isLoading = false;
        
        console.timeEnd('⏱️ Total component load');
        console.log('✅ Data ready, Angular will now render...');
        
        if (this.emailToken) {            
          this.acceptEmailChange();
        }
      },
      error: (err: any) => {
        console.timeEnd('⏱️ Parallel API Calls (getMonthListV2 + getAssociatesNew)');
        console.timeEnd('⏱️ Total component load');
        console.error('❌ API Error:', err);
        this.isLoading = false;
        
        if(err.status === 401) {
          this.auth.logout();
          return
        }
      }
    });

  }

  fncCng(event: any) {
    // 空白行が選択された場合
    if (this.dropDowndate === '') {
      this.associatesList = [];
      return;
    }
    
    let dateFormat = this.getDateFromEvent(event);
    // console.log(this.sectionId);
    this.sectionId = '-1'
    this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(dateFormat));
    this.getAssociatesList(dateFormat);
  }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getAssociatesList(dateFormat: string) {
    // 空文字列の場合はAPI呼び出しをスキップ
    if (!dateFormat || dateFormat === '') {
      this.associatesList = [];
      return;
    }
    
    console.time('⏱️ getAssociatesNew API');
    this.ts.getAssociatesNew(dateFormat, this.sectionId)
      .subscribe({
        next: (res: any) => {
          console.timeEnd('⏱️ getAssociatesNew API');
          console.log('📊 Raw associates data count:', res.data?.length);
          console.time('⏱️ Data Processing');
          
          // 最適化: 1回のループで全処理を実施 + 暗号化キャッシング（第1ソート: customerOfficeCode, 第2ソート: userCode）
          this.associatesList = [...(res.data ?? [])].sort((a: any, b: any) =>
            (a.customerOfficeCode ?? '').localeCompare(b.customerOfficeCode ?? '', 'en', { sensitivity: 'variant' })
          ).map((section: any) => {
            const searchTexts = [section.customerOfficeName];
            
            const encryptedSummaries = [...(section.summaries ?? [])].sort((a: any, b: any) =>
              (a.userCode ?? '').localeCompare(b.userCode ?? '', 'en', { sensitivity: 'variant' })
            ).map((associates: any) => {
              searchTexts.push(associates.userName);
              
              return {
                ...associates,
                timesheetID: this.encryptWithCache(associates.timesheetID.toString()),
                userId: this.encryptWithCache(associates.userId.toString()),
                userIdOrg: associates.userId,
                timesheetIDOrg: associates.timesheetID
              };
            });
            
            const officeName = (section.customerOfficeName ?? '').slice(4);
            const officeCode = section.customerOfficeCode ?? '';
            const companyNamePart = (section.customerName ?? '').slice(9);

            const displaySection = officeName || (section.customerOfficeName ?? '');
            
            return {
              comSearchText: searchTexts.join(' ').toLowerCase(),
              ...section,
              displaySection,
              summaries: encryptedSummaries
            };
          });
          
          console.timeEnd('⏱️ Data Processing');
          // console.log(this.associatesList)
          this.totalCount = this.associatesList?.length;
          console.log('📊 Processed associates count:', this.totalCount);
          this.applyFilters(); // Initialize filters and pagination
          console.timeEnd('⏱️ Total component load');
          console.log('✅ Data ready, Angular will now render...');
        },
        error: (err: any) => {
          console.timeEnd('⏱️ getAssociatesNew API');
          console.timeEnd('⏱️ Total component load');
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          }
        }
      });

  }
  
  cngSection(sectionId: any) {
    this.sectionId = sectionId;
    console.log(this.dropDowndate);
    let curDateArr = this.dropDowndate.split('-');
    let newDateFormat = `${curDateArr[2]}-${curDateArr[1]}-${curDateArr[0]}`;
    console.log(curDateArr[2]);
    this.getAssociatesList(newDateFormat);
  }

  ngAfterViewInit() {
    // Initially set to full dataset
  }

  applyFilterGlobal($event: Event) {
    // Deprecated - using manual filter now
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    // Deprecated - using manual filter now
  }

  onPage(event: any) {
    // Deprecated - using manual pagination now
  }

  onSort() {
    // Deprecated
  }

  updateVisibleData(event?: any) {
    // Initialize filtered data on first load
    if (this.filteredData.length === 0 && this.associatesList.length > 0) {
      this.filteredData = [...this.associatesList];
      this.updatePaginatedData();
    }
  }

  // Compute totals dynamically
  get totalRegular() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.regular;
        if (!timeStr) return;

        const parts = timeStr.split(':').map(Number);
        const h = parts[0] || 0;
        const m = parts[1] || 0;

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h * 3600 + m * 60;
        }
      });
    });

    return this.formatSeconds(totalSeconds);
  }
  
  get totalOverTime() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.overtime;
        if (!timeStr) return;

        const parts = timeStr.split(':').map(Number);
        const h = parts[0] || 0;
        const m = parts[1] || 0;

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h * 3600 + m * 60;
        }
      });
    });

    return this.formatSeconds(totalSeconds);
  }
  get totalMn() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.midnightOvertime;
        if (!timeStr) return;

        const parts = timeStr.split(':').map(Number);
        const h = parts[0] || 0;
        const m = parts[1] || 0;

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h * 3600 + m * 60;
        }
      });
    });

    return this.formatSeconds(totalSeconds);
  }
  get overAllTotal() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.total;
        if (!timeStr) return;

        const parts = timeStr.split(':').map(Number);
        const h = parts[0] || 0;
        const m = parts[1] || 0;

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h * 3600 + m * 60;
        }
      });
    });

    return this.formatSeconds(totalSeconds);
  }
  get totalNotSubmit() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.notSubmit;
        if (!timeStr) return ;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }
  get totalSubmit() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.submit;
        if (!timeStr) return;
          
        totalSeconds += timeStr;

      });
    });

    return totalSeconds;
  }
  get totalReject() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.reject;
        if (!timeStr) return;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }

  get totalApprove() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.approve;
        if (!timeStr) return;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }
  get totalHome() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.teleWork;
        if (!timeStr) return;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }
  get totalAbsence() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.absence;
        if (!timeStr) return;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }
  get totalPh() {
    let totalSeconds = 0;

    this.visibleData.forEach(section => {
      section.summaries.forEach((asso: any) => {
        const timeStr = asso?.paidHoliday;
        if (!timeStr) return;

        totalSeconds += timeStr;
      });
    });

    return totalSeconds;
  }

  formatSeconds(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    // const seconds = totalTime % 60;
    // :${ this.pad(seconds) }
    return `${hours}:${this.pad(minutes)}`;
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
  
  getMonthYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }
  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      dt[ind].timesheetID = Base64UrlService.encode(this.en.encryptionAES(elm.timesheetID.toString()))
      dt[ind].userId = Base64UrlService.encode(this.en.encryptionAES(elm.userId.toString()))
    });
    return dt;
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  // getColumnTotal(field: string) {
  //   return this.associatesList.reduce((sum, item) => sum + (item[field] || 0), 0);
  // }

  createSingleAll(staffId: string, loginId: string) {
    let curDateArr = this.dropDowndate.split('-');
    let newDateFormat = `${curDateArr[2]}-${curDateArr[1]}-${curDateArr[0]}`;
    const yearMonth = `${curDateArr[2]}-${curDateArr[1]}`;
      this.ts.downloadTimesheet(newDateFormat, staffId)
        .subscribe({
          next: (res: any) => {
            // Create a blob from the response
            const blob = new Blob([res.body ?? res], { type: 'application/zip' });

            // Create a temporary download link
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;

            // Optional: derive filename from API or generate dynamically
            a.download = `Summary-${yearMonth}-${loginId}.zip`;

            // Trigger the download
            a.click();

            // Cleanup
            URL.revokeObjectURL(fileURL);
          },
          error: (err: any) => {
            console.error('Error downloading file:', err);
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }

  dwnLedgerPdf(asso: any) {
    this.ts.getPdf(asso.timesheetIDOrg)
      .subscribe({
        next: (res: any) => {
          const blob = new Blob([res.body ?? res], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
            return;
          }
        }
      });
  }

  // Manual pagination and filtering methods
  onSearchFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    this.searchText = value;
    this.currentPage = 1;
    this.applyFilters();
  }
  
  applyFilters() {
    if (!this.searchText) {
      this.filteredData = [...this.associatesList];
    } else {
      this.filteredData = this.associatesList.filter(section => 
        section.comSearchText?.includes(this.searchText)
      );
    }
    this.updatePaginatedData();
  }
  
  updatePaginatedData() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    
    // ページング: スタッフ単位で20行
    let currentCount = 0;
    this.visibleData = [];
    
    for (const section of this.filteredData) {
      if (currentCount >= end) break;
      
      const summaries = section.summaries || [];
      const remainingInPage = end - currentCount;
      const startInSection = Math.max(0, start - currentCount);
      
      // このセクションにページ範囲が含まれるか確認
      if (currentCount + summaries.length > start) {
        const visibleSummaries = summaries.slice(startInSection, startInSection + remainingInPage);
        
        if (visibleSummaries.length > 0) {
          this.visibleData.push({
            ...section,
            summaries: visibleSummaries
          });
        }
      }
      
      currentCount += summaries.length;
    }
  }

  // Get total number of associates across all sections
  getTotalAssociatesCount(): number {
    return this.filteredData.reduce((total, item) => {
      return total + (item.summaries ? item.summaries.length : 0);
    }, 0);
  }
  
  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }
  
  get paginationInfo(): string {
    if (this.filteredData.length === 0) return '0 entries';
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, this.filteredData.length);
    return `${start} to ${end} of ${this.filteredData.length} entries`;
  }
  
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }
  
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }
  
  goToPage(page: number) {
    this.currentPage = page;
    this.updatePaginatedData();
  }
  
  // PrimeNG Paginator event handler
  onPageChange(event: any) {
    this.currentPage = event.page + 1; // PrimeNG uses 0-based index
    this.itemsPerPage = event.rows;
    this.updatePaginatedData();
  }

  // Get paginator template with correct indexing (based on associates count)
  getPaginatorTemplate(): string {
    const totalAssociates = this.getTotalAssociatesCount();
    if (totalAssociates === 0) {
      return this.translate.instant('Showing') + ' 0 ' + this.translate.instant('entries');
    }

    const start = (this.currentPage - 1) * this.itemsPerPage;
    const visibleCount = this.visibleData.reduce((total, item) => {
      return total + (item.summaries ? item.summaries.length : 0);
    }, 0);
    const firstIndex = start + 1;
    const lastIndex = start + visibleCount;

    return this.translate.instant('Showing') + ' ' +
           firstIndex + ' ' +
           this.translate.instant('to') + ' ' +
           lastIndex + ' ' +
           this.translate.instant('of') + ' ' +
           totalAssociates + ' ' +
           this.translate.instant('entries');
  }
  
  toggleRow(index: string) {
    this.expandedRows[index] = !this.expandedRows[index];
  }
}